import { Injectable } from '@angular/core';
import { Pagination } from '@lib/models/pagination.model';
import { Observable } from 'rxjs';
import { HabilitationTabsCounters } from '../models/habilitation-tabs-counters.model';
import { HabilitationStatut } from '@lib/models/demande-habilitation/types/habilitation-statut.type';
import { DemandeHabilitation } from '@lib/models/demande-habilitation/demande-habilitation.model';

@Injectable()
export abstract class DemandeHabilitationsBackOfficeService {
  public readonly aAffecterStatuts: HabilitationStatut[] = ['a_affecter'];
  public readonly aControlerStatuts: HabilitationStatut[] = [
    'a_controler',
    'controle_en_cours',
    'nc_traitee',
  ];
  public readonly actionAEffectuerStatuts: HabilitationStatut[] = ['action_backoffice'];
  public readonly enAttenteStatuts: HabilitationStatut[] = [
    'nc_a_traiter',
    'action_consultant',
  ];
  public readonly enAttenteServiceExterneStatuts: HabilitationStatut[] = [
    'attente_service_externe',
  ];
  public readonly historiqueStatuts: HabilitationStatut[] = [
    'expire',
    'valide',
    'refuse',
    'annule',
  ];

  abstract watchDemandesCountByCategories(): Observable<HabilitationTabsCounters>;
  abstract refreshCounts(): void;
  abstract getDemandeHabilitations(
    search: string | null,
    statuts: HabilitationStatut[],
    gestionnaireCodes: string[],
    pageIndex: number,
    pageSize: number,
    sortField: 'dateDeclaration' | 'dateUpdate',
    sortOrder: 'asc' | 'desc'
  ): Promise<Pagination<DemandeHabilitation>>;
  abstract affecterDemandeHabilitation(
    publicIds: string[],
    gestionnaireId: string
  ): Promise<void>;
  abstract refuserDemandeHabilitation(
    publicId: string,
    commentaire: string
  ): Promise<void>;
}
